import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { FormatsService } from '@techrules/pipelib';

import moment from 'moment';

@Injectable()
export class TechDateAdapter extends MomentDateAdapter {
  constructor(private formatSvc: FormatsService) {
    super(formatSvc.locale);
  }

  public format(date: moment.Moment, displayFormat: string): string {
    const locale = this.formatSvc.locale;
    const format =
      displayFormat === 'l' ? this.formatSvc.dateFormat : displayFormat;

    const result = date.locale(locale).format(format);

    //console.log(`Reading date [local: '${ locale }'; format: '${ format }'; result: '${ result }']`);

    return result;
  }
}
